import { useEffect, useState } from 'react';
import { FormInstance } from 'antd';

export const useHasValidDisputeFiles = (form: FormInstance) => {
  const [valid, setValid] = useState(true);

  // Antd does not update refs
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    let mounted = true;

    form
      .validateFields(['files'])
      .then(() => {
        mounted && setValid(true);
      })
      .catch(() => {
        mounted && setValid(false);
      });

    return () => {
      mounted = false;
    };
  });

  return valid;
};
